// extracted by mini-css-extract-plugin
export var checkbox = "_6p-0";
export var circle = "_6p-3";
export var horizontalContainer = "_6p-7";
export var sm = "_6p-5";
export var switch0 = "_6p-2";
export var switchDisabled = "_6p-8";
export var switchEnabled = "_6p-1";
export var textSwitchContainer = "_6p-9";
export var textSwitchOption = "_6p-a";
export var textSwitchOptionSelected = "_6p-b";
export var verticalContainer = "_6p-6";
export var xs = "_6p-4";